import { get } from '@/utils/apiBase.js'

// 获取战报荣誉时刻 
const getProjectHonorInfo = option => {
    return get('/apis/project/get_pro_rank_honors', option)
}

// 获取战报荣誉时刻列表
const getProHonorList = option => {
    return get('/apis/project/get_pro_rank_achievements', option)
}

// 获取战报荣誉时刻海报 
const getProHonorShareImg = option => {
    return get('/apis/project/rank_report_share_img', option)
}


export default {
    getProjectHonorInfo,
    getProHonorList,
    getProHonorShareImg
}